import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import * as PropTypes from 'prop-types'
import i18n from 'support/i18n'
import styles from './View.Style'

const NxtCurrency = props => {
  const { classes, hasIconLeftSide, iconName, currencyConfiguration, children } = props
  return (
    <span className={classes.root}>
      {hasIconLeftSide && (
        <>
          {iconName && <span className={`icon-${iconName}`} />}
          {i18n.toCurrency(children, currencyConfiguration)}
        </>
      )}
      {!hasIconLeftSide && (
        <>
          {i18n.toCurrency(children, currencyConfiguration)}
          {iconName && <span className={`icon-${iconName}`} />}
        </>
      )}
    </span>
  )
}

NxtCurrency.defaultProps = {
  hasIconLeftSide: true,
  iconName: '',
  currencyConfiguration: {},
}

NxtCurrency.propTypes = {
  hasIconLeftSide: PropTypes.bool,
  iconName: PropTypes.string,
  currencyConfiguration: PropTypes.shape({}),
}

export default withStyles(styles)(NxtCurrency)
